export const tranferConstants = {
    TRANFER_SELECTED: 'TRANFER_SELECTED'
  }